// API Route
export const REDEEM_API_ROUTE = process.env.REACT_APP_WEB_API_HOST + "/redeem/";
export const VALIDATE_API_ROUTE = process.env.REACT_APP_WEB_API_HOST + "/validate/";

// Route
export const VALIDATE_ROUTE = "/v/";
export const REDEEM_ROUTE = "/redeem/";
export const RETRY_ROUTE = "/retry/";
export const NOT_FOUND_ROUTE = "/not-found";
export const HEALTH_CHECK_ROUTE = "/health_check";
export const OTHER_REDEEM_ROUTE = "/code-redeemed/";

// Status
export const AVAILABLE = "available";
export const REDEEMED = "redeemed";
export const INVALID = "invalid";
export const FAILED = "failed";
export const OTHER_REDEEM = "redeemed_other";

// Title
export const TITLE_VALIDATE = "Validation";
export const TITLE_REDEEMED_CODE = "Redeemed Game Code";
export const TITLE_RETRY = "Retry";
export const TITLE_NOT_FOUND = "404";
export const TITLE_OTHER_REDEEM = "Another Game Code Redeemed";
export const TITLE_HEALTH_CHECK = "Health Check";

// Message
export const MESSAGE_NOT_FOUND = "So sorry. We are unable to find this page.";
export const MESSAGE_REDEEM_FAILED = "So sorry. We are unable to redeem your game code. Please retry again.";
export const MESSAGE_OTHER_REDEEM = "You had redeemed another game code. Please click the button below to view your game code.";